import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import {
  useGetBackofficeSchoolsQuery,
  useAddBackofficePostulationMutation,
  useLazyGetBackofficeSchoolProgramsQuery,
} from 'services/exploreApi';
import Text from 'common/components/Text/Text';

interface CompProps {
  show: boolean;
  setShow: (show: boolean) => void;
}
const PostulationModal = ({ show, setShow }: CompProps): React.ReactElement => {
  const handleClose = () => setShow(false);
  const { id } = useParams<{ id: string }>();
  const {
    data: schools,
    isLoading: isSchoolsLoading,
    isFetching: isSchoolsFetching,
  } = useGetBackofficeSchoolsQuery({});

  const [
    getPrograms,
    { data: programs, isLoading: programsLoading, isFetching: programsFetching },
  ] = useLazyGetBackofficeSchoolProgramsQuery();

  const [submitBackofficePostulation] = useAddBackofficePostulationMutation();

  const [school, setSchool] = useState<any>({ label: '', value: 0 });
  const [program, setProgram] = useState<any>({ label: '', value: 0 });

  useEffect(() => {
    if (school.value > 0) {
      setProgram({ label: '', value: 0 });
      getPrograms(school.value);
    }
  }, [school]);

  const handleClick = () => {
    const values = { program_id: program.value, user_id: parseInt(id || '1') };
    submitBackofficePostulation(values).then((resp: any) => {
      handleClose();
    });
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Create a new application</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Text size={14} weight={600}>
            Select school
          </Text>
          <Select
            isSearchable
            classNamePrefix="react-select"
            options={[...(schools?.data.map((c) => ({ label: c.name, value: c.id })) || [])]}
            isLoading={isSchoolsLoading || isSchoolsFetching}
            onChange={(school: any) => setSchool(school)}
            value={school}
          />
        </div>
        <div>
          <Text size={14} weight={600}>
            Select program
          </Text>
          <Select
            isSearchable
            classNamePrefix="react-select"
            options={[...(programs?.data.map((c) => ({ label: c.name, value: c.id })) || [])]}
            isLoading={programsLoading || programsFetching}
            onChange={(program: any) => setProgram(program)}
            value={program}
          />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleClick} disabled={program.value == 0}>
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PostulationModal;
